import type { FC } from "react";
import { useSelector } from "react-redux";
import { getTermsAccepted } from "../../store/auth";
import { AcceptTerms } from "./AcceptTerms";
import { StrongAuthSelection } from "./StrongAuthSelection";

export const Signup: FC = () => {
  const accepted = useSelector(getTermsAccepted);

  if (accepted) {
    return <StrongAuthSelection />;
  }
  return <AcceptTerms />;
};
